import * as tslib_1 from "tslib";
import { suggestionSelected } from '../actions/publicActions';
import { CLICK_ACTION_SOURCE } from '../searchConstants';
import { observer } from 'mobx-react';
import { getIconForFile } from 'owa-file-icon';
import * as React from 'react';
import highlightDisplayText, { dehighlightDisplayText, } from './suggestionsContextMenu/highlightDisplayText';
var styles = require('./SuggestionsContextMenu.scss');
var classNames = require('classnames/bind');
var FileSuggestionMenuItem = /** @class */ (function (_super) {
    tslib_1.__extends(FileSuggestionMenuItem, _super);
    function FileSuggestionMenuItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FileSuggestionMenuItem.prototype.render = function () {
        var suggestion = this.props.suggestion;
        var fileIcon = getIconForFile(suggestion.Name);
        var highlightTextRegions = highlightDisplayText(suggestion.HighlightedDisplayText);
        return (React.createElement("div", { className: styles.fileSuggestion, key: suggestion.Name, tabIndex: 0, 
            // VSO:17221 as a part of 17221, we should change onMouseDown to onClick
            onMouseDown: function () {
                suggestionSelected(suggestion, CLICK_ACTION_SOURCE);
            }, title: dehighlightDisplayText(suggestion.HighlightedDisplayText) },
            React.createElement("div", { className: styles.fileIconContainer, "data-is-focusable": false },
                React.createElement("i", { className: classNames(fileIcon.small, styles.fileIcon) })),
            React.createElement("div", { className: styles.fileInfoContainer, "data-is-focusable": false }, highlightTextRegions.filter(function (e) { return e.text.length > 0; }).map(function (e) {
                var className = e.isHighlighted
                    ? styles.keywordMatchSuggestion
                    : styles.keywordNonMatchSuggestion;
                return React.createElement("div", { className: className }, e.text);
            }))));
    };
    FileSuggestionMenuItem = tslib_1.__decorate([
        observer
    ], FileSuggestionMenuItem);
    return FileSuggestionMenuItem;
}(React.Component));
export default FileSuggestionMenuItem;
//# sourceMappingURL=FileSuggestionMenuItem.js.map